"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const PublicGlobalClientUtilities = dynamic(
  () =>
    import("./PublicGlobalClientUtilities").then(
      module => module.PublicGlobalClientUtilities
    ),
  { ssr: false }
);

interface DeferredPublicGlobalClientUtilitiesProps {
  gaId: string;
}

type IdleWindow = Window &
  typeof globalThis & {
    requestIdleCallback?: (
      callback: IdleRequestCallback,
      options?: IdleRequestOptions
    ) => number;
    cancelIdleCallback?: (handle: number) => void;
  };

export function DeferredPublicGlobalClientUtilities({
  gaId,
}: DeferredPublicGlobalClientUtilitiesProps) {
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    const win = window as IdleWindow;

    if (win.requestIdleCallback) {
      const idleId = win.requestIdleCallback(() => setShouldMount(true), {
        timeout: 2000,
      });
      return () => win.cancelIdleCallback?.(idleId);
    }

    const timeoutId = window.setTimeout(() => setShouldMount(true), 1200);
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!shouldMount) {
    return null;
  }

  return <PublicGlobalClientUtilities gaId={gaId} />;
}
